import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { spacing } from 'ui/theme';

import {
  selectIsEmbeddedMessagingCoreFeatureFlagOn,
  selectIsWhatsAppInfobipLocalesEnabled,
} from 'core/userContext/selectors';
import { MessageMedium } from 'modules/graphql/types';
import { useQueryPlacementById } from 'modules/placements/hooks/useQueryPlacementById';
import {
  TemplateDetailsBlock,
  TemplateDetailsContainer,
} from 'modules/templateEditor/common/EditableHeader/EditableHeader.styled';
import { MESSAGE_MEDIUM_LABELS } from 'modules/templateEditor/common/constants';
import { useTemplateQueryContext } from 'modules/templateEditor/context/TemplateQueryContext';
import { useInStudioTakeoverContext } from '../../context';
import { WHATS_APP } from 'constants/messageMediums';
import { approvalStatusQualityMapper } from 'modules/campaigns/lib/constants';

const StyledTemplateDetails = styled(TemplateDetailsContainer)`
  margin-bottom: -${spacing.base};
`;

export const TemplateDetailsSubHeader = () => {
  const isWhatsAppGAEnabled = useSelector(selectIsWhatsAppInfobipLocalesEnabled);
  const isEmbeddedMessagingEnabled = useSelector(selectIsEmbeddedMessagingCoreFeatureFlagOn);
  const { templateId } = useInStudioTakeoverContext();
  const { medium, template: templateString } = useTemplateQueryContext();
  const template = JSON.parse(templateString || '{}');
  const placementId = template?.mediumData?.placementId ?? null;
  const { placement } = useQueryPlacementById(placementId);
  const { metaApprovalStatus, qualityRating } = template?.mediumData ?? {};

  return (
    <StyledTemplateDetails data-test="template-details-info">
      <TemplateDetailsBlock>{MESSAGE_MEDIUM_LABELS[medium as MessageMedium]}</TemplateDetailsBlock>
      {isEmbeddedMessagingEnabled && placement.placementName && (
        <TemplateDetailsBlock>{placement.placementName}</TemplateDetailsBlock>
      )}
      <TemplateDetailsBlock>{`Template ID: ${templateId}`}</TemplateDetailsBlock>
      {medium === WHATS_APP &&
        isWhatsAppGAEnabled &&
        metaApprovalStatus &&
        approvalStatusQualityMapper(metaApprovalStatus, qualityRating)}
    </StyledTemplateDetails>
  );
};
